import React from 'react';
import { useStory } from './StoryContext';
import { EBook } from './EBook';
export const StoryEbookWrapper = () => {
  const {
    showEbook
  } = useStory();
  return showEbook ? <EBook data-id="element-902" /> : null;
};